import '../../../rubberduck/dist/js/import-jquery-light.js';
import { backgroundSetter } from '../../../rubberduck/dist/lib/rubberduck/backgroundSetter/backgroundSetter.js';
import { EventCalendarHandler } from '../../../../app/src/rubberduck/event/src/Event/dist/js/EventCalendarHandler.js';
import { GDPRHandler } from '../../../../app/src/rubberduck/core/src/GDPR/dist/js/GDPRHandler.js';
import { QuackFormHandler } from '../../../../app/src/rubberduck/cms/src/Form/dist/QuackFormHandler.js';
import { PropertyHandler } from '../../../../app/src/rubberduck/property/dist/js/PropertyHandler.js';
import { Pagination } from '../../../rubberduck/dist/lib/rubberduck/pagination/pagination2.build.js';
import { viewport } from '../../../rubberduck/dist/js/utils.js';

require('is-in-viewport/lib/isInViewport.min.js');

var $html = $('html');
var $body = window.$body = $('body');
var $nav = $('.RGO000-A');
var $menu = $('.menu');
var $content = $('.content');

var bgSetter = null;

var isIE = window.document.documentMode;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

var lang = $html.attr('lang');

var prev_url = '';

var history_timeout;

let propertyHandler;

//$.fancybox.defaults.hash = false;

// Fade out content on page refresh
window.onbeforeunload = function (e) {
    if (
        typeof e.target.activeElement.href === 'undefined' ||
        e.target.activeElement.href.indexOf('tel:') == -1 &&
        e.target.activeElement.href.indexOf('mailto:') == -1
    ) {
        // Only when it is not a phone or mail link
        $html.addClass('is-animating');
        reset();
    }
}

function onLoad() {
    $content = $('.content');

    if (document.querySelector(".desktop_categories") !== null) {
        overflowCategoryCheck();
    }

    // GDPR
    if (typeof GDPRHandler != 'undefined') {
        let gdpr = new GDPRHandler();
        gdpr.init();
    }

    $('#main .article_sections .sections-flex > *').each(function(index, section) {
        if ($(section).css('background-color') == $(section).next().css('background-color')) {
            $(section).next().addClass('no_padding');
        }
    });

    // Google map on page reentry
    if (typeof initMap !== 'undefined') initMaps();

    // MENU AUTO ACTIVE STATE
    let currentURL = window.location.href;
    let $nav_links = $('a', $nav);
    let $menu_links = $('a', $menu);
    let $footer_links = $('a', $('footer'));
    let $all_links = $nav_links.add($menu_links).add($footer_links);

    // Nav and menu links
    for (let i = 0; i < $all_links.length; i++) {
        const $el = $all_links.eq(i).removeClass('active');
        if (
            currentURL == $el.attr('href') ||
            currentURL.includes($el.attr('href') + '/') ||
            currentURL.includes($el.attr('href') + '?')
        ) {
            setTimeout(function () {
                $el.addClass('active');
            }, 10)
        }
    }

    // copy link
    if ($('.copy_link').length) {
        $('.copy_link').on('click', function () {
            navigator.clipboard.writeText(window.location.href);
            $('.alert_copy').slideDown();
            setTimeout(() => {
                $('.alert_copy').slideUp();
            }, 2000);
        })
    }

    // MENU DISTRIBUTE THE LINKS EQUAL PARTS (ONLY ON MORE THAN TABLETS)
    // if (window.innerWidth > 1024) {
    //     menu_distribute_links();
    // }

    ///////////////////////////////////////////////////////////////////////////
    // CLOSE RGO16
    ///////////////////////////////////////////////////////////////////////////
    $('.RGO16__close').on('click', function () {
        $('.RGO16').addClass('closing');
        $('.RGO16__box').slideUp(500);
    })

    ///////////////////////////////////////////////////////////////////////////
    // CLOSE RGO18
    ///////////////////////////////////////////////////////////////////////////
    $('.RGO18 .close-popup').on('click', function () {
        $(this).closest('.RGO18').slideUp(function() {
            $(this).remove();
        });
    })

    ///////////////////////////////////////////////////////////////////////////
    // DATEPICKER
    ///////////////////////////////////////////////////////////////////////////
    $('.form_datepicker').datepicker({
        beforeShow: function (input, inst) {
            inst.dpDiv.css({
                marginLeft: input.offsetWidth + 'px'
            });
            var classArr = $(input).closest('section').attr('class').split(/\s+/);
            $.each(classArr, function(index, value){
                if (value.startsWith('RM')) inst.dpDiv.addClass(value + '-ui-datepicker');
            });
        }
    });

    ///////////////////////////////////////////////////////////////////////////
    // SELECT2
    ///////////////////////////////////////////////////////////////////////////
    let select2_options = {
        debug: true,
        width: '100%',
        minimumResultsForSearch: Infinity,  // Hide the search input
        theme: '',
        language: lang
    }
    $selects = $('select');
    for (let i = 0; i < $selects.length; i++) {
        let $el = $selects.eq(i);
        select2_options.dropdownParent = $el.parent();
        $el.select2(select2_options)
            .on('select2:open', function (e) {
                // Search
                $('.select2-search__field').attr('placeholder', (lang == 'fr' ? 'Recherche' : 'Search'));

                let $dropdown = $('.select2-dropdown');
                $dropdown.hide();
                setTimeout(function () { $dropdown.slideDown(250); }, 10);
            });
    }

    ///////////////////////////////////////////////////////////////////////////
    // MIXITUP
    ///////////////////////////////////////////////////////////////////////////
    function handleResetFiltersVisiblity() {
        $('.reset_filters').each(function() {
            let hide = true;
            let btn = $(this);
            let inputs = btn.closest('form').find('input:not([type="hidden"]), select');
            inputs.each(function(index, input) {
                if (hide) hide = ($(input).val() == '');
                if (index == (inputs.length - 1)) btn.toggleClass('hide_reset', hide);
            });
        });
    }

    function filterPagination() {
        if ($('.pagination_wrapper').length > 0) {
            if ($pagination.htmlWrapper.length > 0 && $pagination.htmlContentWrapper.length > 0) {
                $pagination.fetchAjaxInformationPagination(
                    false,// UPDATE: Si le nombre maximum d’élément change, le script à besoin de savoir si on update les éléments (true) ou on les remplaces (false).
                    true, // KEEP_NB_SELECT: Est-ce que le nombre d’éléments affichés par pages reste le même ou non.
                    false // RESET: Si on doit simplement remettre la pagination à la première page en gardant le nombre d’éléments affichés par pages.
                );
                handleResetFiltersVisiblity();
            }
        }
    }
    $body.on('change', '.filter_sub select:not(.no_trigger)', function (e) {
        filterPagination();
    });

    $body.on('click', '.trigger_filters', function (e) {
        e.preventDefault();
        filterPagination();
    });

    $body.on('click', '.reset_filters', function (e) {
        e.preventDefault();
        let container = $(this).closest('.filter_container');
        // Uncheck all
        container.find('.filter_sub [type="checkbox"], .filter_sub [type="radio"]').prop('checked', false).parents('li.active').removeClass('active');
        container.find('.filter_sub select').addClass('no_trigger').val('').trigger('change').removeClass('no_trigger');
        // Check "View All"
        container.find('.filter-iceberg .filter_container > ul > .filter_sub:first-child').addClass('active');
        filterPagination();
    });

    // if ($('.pagination_wrapper').length > 0) {
    //     $(document).ajaxComplete(function () {
    //         if ($('.pagination_btn.next').hasClass('disabled') &&
    //             $('.pagination_btn.prev').hasClass('disabled')
    //         ) {
    //             $('.pagination_wrapper').css('display', 'none');
    //         } else {
    //             $('.pagination_wrapper').css('display', 'block');
    //         }
    //     })
    // }
    $body.on('change', '.desktop_categories li input', function (e) {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        filterPagination();
        let interval = setInterval(() => {
            if ($('main #loader').hasClass('is-fading-out')) {
                $(window).trigger('scroll');
                clearInterval(interval)
            }
        }, 500);
    });
    $body.on('click', '.tags--reset.clear-form', function (e) {
        filterPagination();
    });


    if ($('.mixitup').length && $('.filtered:not(.pagination_content_wrapper)').length) {
        var mixitup = require('mixitup');
        var mixitupMultifilter = require('../lib/mixitup/mixitup-multifilter.min.cjs');
        mixitup.use(mixitupMultifilter);
        var mixit = mixitup('.filtered:not(.pagination_content_wrapper)', {
            selectors: {
                target: '.filtered_items',
                control: '.mixitup li'
            },
            multifilter: {
                enable: true
            },
            callbacks: {
                onMixEnd: function(state) {
                    $(window).trigger('scroll');
                },
                onMixClick: function(state, originalEvent) {
                    $(state.container).closest('section').find('.mixitup .filter_container .searchbar input').val('');
                }
            }
        });
        const delay = (function(){
            var timer = 0;
            return function(callback, ms){
                clearTimeout (timer);
                timer = setTimeout(callback, ms);
            }
        })();
        var mixitupContainer, mixitupItems, mixitupSearchInputText;
        $body.on('input', '.mixitup.filters .filter_container .searchbar input', function() {
            mixitupSearchInputText = $(this).val().toLowerCase();
            mixitupContainer = $(this).closest('section');
            mixitupItems = mixitupContainer.find('.filtered .filtered_items');
            // Delay function invoked to make sure user stopped typing
            delay(function(){
                // Reset category to 'all'
                let filter = mixitupContainer.find('.desktop_categories [data-filter].active');
                if (filter.length) {
                    filter.removeClass('active');
                    filter.find('input').prop('checked', false);
                    mixitupContainer.find('.desktop_categories [data-filter="all"]').addClass('active').find('input').prop('checked', true);
                }
                var matching = $();
                // Check to see if input field is empty
                if ((mixitupSearchInputText.length) > 0) {            
                    mixitupItems.each(function() {
                        // add item to be filtered out if input text matches items inside the title   
                        if ($(this).text().toLowerCase().match(mixitupSearchInputText)) {
                            matching = matching.add(this);
                        } else {
                            // removes any previously matched item
                            matching = matching.not(this);
                        }
                    });
                    mixit.filter(matching);
                } else {
                    // resets the filter to show all item if input is empty
                    mixit.filter('all');
                }
            }, 200);
        });

        $('.filtered:not(.pagination_content_wrapper)').on('mixEnd', function () {
            $(window).trigger('resize');
        });
    }

    // ON SELECT CHANGE CATEGORIES
    $('.select_filters').on('change', function (e) {
        let val = $(this).val();
        let radios = $(this).closest('.filter_container').find('.desktop_categories li');
        let filter;

        radios.each(function () {
            let label = $(this).closest('label');
            let radio = $(this).find('input[type="radio"]').first();

            if (radio.val() == val) {
                filter = $(this).closest('li').data('filter');
                radio.prop('checked', true);
                label.click();
            } else {
                radio.prop('checked', false);
            }
        });
        if ($('.filtered').is(':visible')) {
            mixitup('filter', filter);
        }

        filterPagination();
    });



    ///////////////////////////////////////////////////////////////////////////
    // PAGINATION
    ///////////////////////////////////////////////////////////////////////////

    if ($('.pagination_wrapper').length > 0) {
        let number_per_page = 24;
        let current_page = 1;
        let params = window.location.search.substr(1).split('&');
        if (params.length > 0) {
            for (let i = 0; i < params.length; i++) {
                let pair = params[i].split('=');
                let key = pair[0];
                if (key == 'number_items') {
                    number_per_page = parseInt(pair[1]);
                }
                if (key == 'page') {
                    current_page = parseInt(pair[1]);
                }
            }
        }
        $pagination = new Pagination({
            display_go_to: false,
            size_list: 'mini',
            number_items_per_page: number_per_page,
            call_back_return: 'updatePagination'
        });

        $pagination.currentPage = current_page;

        filterPagination();
    }

    /////////////////////////////////////////
    // MIXITUP TAGS FILTER BUTTON
    ////////////////////////////////////////

    let $filterBtn = $('.tags--btn');

    $body.on('click', '.tags--btn:not(.dropping)', function (e) {
        e.stopPropagation();
        $(this).addClass('dropping');
    });
    $body.on('click', function (e) {
        let target = $(e.target);
        if (target.hasClass('tags--btn') || target.closest('.tags--icon')) {
            $('.tags--btn').removeClass('dropping');
        }
    });


    // MIXITUP LI GET ACTIVE CLASS ON CLICK
    let categoriesArr = $('.desktop_categories li');

    categoriesArr.each(function () {
        let radio = $(this).find('input[type="radio"]');
        radio.on('change', function () {
            if (radio.prop('checked') == true) {
                categoriesArr.removeClass('active');
                $(this).closest('li').addClass('active');
            } else {
                $(this).removeClass('active');
            }
        })
    })

    // MIXITUP TAGS GET ACTIVE ON CLICK
    let tagsCheckboxes = $('.tags--dropdown input[type="checkbox"]');
    tagsCheckboxes.each(function () {
        $(this).on('change', function () {
            if ($(this).is(':checked') == true) {
                $(this).closest('li').addClass('active');
            } else {
                $(this).closest('li').removeClass('active');
            }
            filterPagination();
        })
    })

    /// END OF MIXITUP JAVASCRIPT

    ///////////////////////////////////////////////////////////////////////////
    // SCROLL ARROW
    ///////////////////////////////////////////////////////////////////////////
    $(".page-scroll").on('click', function () {
        var targetDiv = $(this).attr('href') || $(this).attr('data-target');
        // if (targetDiv) targetDiv = $(this).data('target');

        scrollPage(targetDiv, $nav.height() - 20);

        return false;
    });

    // Scrolled to hash on load (no animation)
    if (window.location.hash != '') {
        window.scrollTo(0, $(window.location.hash).offset().top - $nav.height());
    }

    setTimeout(function () { // allowing 3 secs to fade out loader
        $('.loader').fadeOut('fast');
    }, 500);

    $(window).trigger('resize').trigger('scroll');

    if (typeof EventCalendarHandler != 'undefined') {
        calendar_handler = new EventCalendarHandler();
        calendar_handler.init();
    }

    ///////////////////////////////////////////////////////////////////////////
    // RECAPTCHA
    ///////////////////////////////////////////////////////////////////////////
    let form_handler = new QuackFormHandler({
        ajax_selector: 'form:not(.no_ajax):not(.custom_ajax):not(.filter_container)',
        no_ajax_selector: 'form.no_ajax'
    });

    //////////////////////////////////////////////////////
    //  VIDEOS BUTTONS TOGGLE
    //////////////////////////////////////////////////////
    $body.on('click', '.video__play', function () {
        togglePlayMedia($(this).closest('.video__wrapper'));
    });
    $body.on('click', '.video__volume', function () {
        toggleSoundMedia($(this).closest('.video__wrapper'));
    });

    const videoHasAudio = (video) => {
        return video.mozHasAudio ||
        Boolean(video.webkitAudioDecodedByteCount) ||
        Boolean(video.audioTracks && video.audioTracks.length);
    }
    const videoLoaded = (video) => {
        setTimeout(() => {
            let container = $(video).closest('.video__wrapper');
            container.toggleClass('playing', !video.paused);
            container.toggleClass('volume-up', !video.muted);
            let audio_controls = container.find('.video__volume');
            if (audio_controls.length == 0) return;
            if (videoHasAudio(video) === false) audio_controls.remove();
        }, 250);
    }
    $('video').each(function() {
        if (this.readyState == 4) {
            videoLoaded(this);
        } else {
            this.addEventListener('loadeddata', (e) => {
                videoLoaded(this);
                this.removeEventListener('loadeddata');
            });
        }
    });
    ///////////////////////////////////////////////////////////////////////////
    // Video
    ///////////////////////////////////////////////////////////////////////////
    const handleHeroVideo = (container) => {
        let video = container.querySelector('video');
        if (!video) return;
        $(container).find('.play--bt').toggle(video.paused);
        $(container).find('.pause--bt').toggle(!video.paused);
        $(container).toggleClass('removecontent', !video.paused);
    }
    $('.RGO01-A video, .RGO01-B video, .RGO21 video').each(function() {
        if (this.readyState == 4) {
            handleHeroVideo($(this).closest('.RGO01-A, .RGO01-B, .RGO21 .hero_card').get(0));
        } else {
            this.addEventListener('loadeddata', (e) => {
                handleHeroVideo($(this).closest('.RGO01-A, .RGO01-B, .RGO21 .hero_card').get(0));
                this.removeEventListener('loadeddata');
            });
        }
    });
    $body.on('click', '.play--bt', function () {
        let container = $(this).closest('.RGO01-A, .RGO01-B, .RGO21 .hero_card');
        container.find('video').trigger('play');
        handleHeroVideo(container.get(0));
    });
    $body.on('click', '.pause--bt', function () {
        let container = $(this).closest('.RGO01-A, .RGO01-B, .RGO21 .hero_card');
        container.find('video').trigger('pause');
        handleHeroVideo(container.get(0));
    });

    $body.on('ended', '.RGO01-A video, RGO01-B video, .RGO21 video', function () {
        $(this).siblings('.RGO01__content').find('.play--bt').show();
        $(this).siblings('.RGO01__content').find('.pause--bt').hide();
        $(this).parents('.RGO01-A, .RGO01-B, .RGO21').removeClass('removecontent');
    });
    //////////////////////////////////////////////////////
    //  CLEAR FORM
    //////////////////////////////////////////////////////
    $('.clear-form').on('click', function () {
        $(this).closest('form').trigger('reset');

        if ($('.form-filters') !== null) {
            $('.desktop_categories li').removeClass('active');
            $('.desktop_categories li:first-of-type').addClass('active');
            $('.tags--dropdown ul li').removeClass('active');
        }
    })

    //////////////////////////////////////////////////////
    //  CLOSE POPUPs
    //////////////////////////////////////////////////////
    let closePopup = $('.close-popup');

    closePopup.on('click', function () {
        $(this).closest('.popup').slideUp();
    })

    //////////////////////////////////////////////////////
    // TRIGGER ANY DRODPOWN
    //////////////////////////////////////////////////////

    let dropdownBtn = $('.dropdown-btn');
    let dropdownItems = $('.dropdown-menu');
    let children = dropdownItems.children('li');
    dropdownItems.css('position', 'absolute');

    dropdownBtn.each(function () {
        $(this).on('click', function (e) {
            e.stopPropagation();
            let parent = $(this).closest('.dropdown');
            let dropdownMenu = parent.find('.dropdown-menu');
            parent.toggleClass('opened');
            dropdownMenu.slideToggle();

            //make dropdown work
            let current = $('.menu-calculate .current .selection');
            let selections = $('.menu-calculate .dropdown-menu .option label');

            if (selections !== null) {
                selections.each(function () {
                    $(this).on('click', function () {
                        current.text($(this).text());
                        $(this).closest('.dropdown').removeClass('opened');
                    })
                })
            }
        })
    })

    // Closes dropdown if click on an item
    children.on('click', function () {
        dropdownItems.hide();
    })

    ///////////////////////////////////////////////
    // HIDE APPLY BUTTON IF NO RMF35
    ////////////////////////////////////////////////
    if (document.querySelector('.RMF35') == null) {
        $('.apply').addClass('hide');
    }

    // '####:'##::::'##:'##::::'##::'#######::'########::'####:'##:::::::'####:'########:'########::
    // . ##:: ###::'###: ###::'###:'##.... ##: ##.... ##:. ##:: ##:::::::. ##:: ##.....:: ##.... ##:
    // : ##:: ####'####: ####'####: ##:::: ##: ##:::: ##:: ##:: ##:::::::: ##:: ##::::::: ##:::: ##:
    // : ##:: ## ### ##: ## ### ##: ##:::: ##: ########::: ##:: ##:::::::: ##:: ######::: ########::
    // : ##:: ##. #: ##: ##. #: ##: ##:::: ##: ##.... ##:: ##:: ##:::::::: ##:: ##...:::: ##.. ##:::
    // : ##:: ##:.:: ##: ##:.:: ##: ##:::: ##: ##:::: ##:: ##:: ##:::::::: ##:: ##::::::: ##::. ##::
    // '####: ##:::: ##: ##:::: ##:. #######:: ########::'####: ########:'####: ########: ##:::. ##:
    // ....::..:::::..::..:::::..:::.......:::........:::....::........::....::........::..:::::..::
    function updatePagination(data) {
        if (data.additional_html) {
            if (data.additional_html.tags) {
                let html = '';
                html = data.additional_html.tags;
                if ($('#tags').length) {
                    $('#tags').html(html);
                    $('#tags .iceberg__head.active').next().show();
                }
            }
            if (data.additional_html.info_windows) {
                if (typeof propertyHandler != 'undefined') {
                    propertyHandler.setMapData(data.additional_html.info_windows);
                }
            }
        }
    }
    window['updatePagination'] = updatePagination;

    // PROPERTY
    if (typeof PropertyHandler != 'undefined') {
        propertyHandler = new PropertyHandler();
    }

    if ($('.RMO14').length) {
        let displayBtns = $('.btn-display');
        let properties = $('.RMO14 .properties__list');

        displayBtns.on('click', function () {
            displayBtns.removeClass('active');
            $(this).addClass('active');
            if (properties.hasClass('list')) {
                properties.removeClass('list');
            } else {
                properties.addClass('list');
            }
        })

        // TOGGLE FILTERS ON MOBILE
        $('.filters__container--header').on('click', function () {
            if (viewport().width <= 768) {
                $('.filter-wrapper').slideToggle();
                $('.filters-toggle').toggleClass('opened');
            }
        })
    }

    ///////////////////////////////////////////////
    // RMF08, MAKE APPEAR CONTENT
    ///////////////////////////////////////////////
    if ($('.RMF08').length) {
        let menuItems = $('.RMF08 .menu .menu-item');
        let contentItems = $('.RMF08 .content-wrapper .content');

        menuItems.each(function () {
            $(this).on('click', function () {
                menuItems.removeClass('active');
                $(this).addClass('active');
                let matchingId = $(this).attr("id");

                contentItems.each(function () {
                    if ($(this).hasClass(matchingId)) {
                        $(this).addClass('active')
                    } else {
                        $(this).removeClass('active')
                    }
                })

            })
        })
        // MENU MOBILE
        $('.RMF08__specs--menu select').on('change', function () {
            let value = $(this).val();
            $('.RMF08 .content').each(function () {
                if ($(this).hasClass(value) == true) {
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }
            })
        })
        ///////////////////////////////////////////////
        // CALCULATOR
        ///////////////////////////////////////////////        
        //make menu appear
        $('.RMF08 .calculator').on('click', function () {
            $('.menu-calculate').toggleClass('opened');
            $body.addClass('fixbody');

            $(document).mouseup(function (e) {
                if (e.target === document.querySelector('.menu-calculate')) {
                    $('.menu-calculate').removeClass('opened');
                    $body.removeClass('fixbody');
                }
            });
        })
        //reset button makes reset text
        $('.menu-calculate label.reset').on('click', function () {
            $('#insert_result_here').text($('.original_text').text())
        })
        $('.calculator-wrapper .close').on('click', function () {
            $('.menu-calculate').removeClass('opened');
            $body.removeClass('fixbody');
        })
        if ($('.calculator-wrapper').length > 0) {
            $('#calc_mortgage_payment').on('click', function (e) {
                let $form = $(this).parents('form').first();
                let payment = propertyHandler.calcMortgage($form);
                let formatted_payment = payment + '$ / ' + $form.find('[name="payment_frequency"] option:selected').text();
                $('#insert_result_here').text(formatted_payment);
            });
        }

        ///////////////////////////////////////////////
        // RMF08 QUANTITY BUTTONS
        ///////////////////////////////////////////////
        $('.menu-calculate .quantity .plus').on('click', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let inputVal = input.val();
            var plus = '';

            if (isNaN(inputVal) || input.val() == "") {
                plus = 0 + 1;
            } else {
                plus = parseInt(inputVal) + 1;
            }
            input.val(plus);

        })
        $('.menu-calculate .quantity .minus').on('click', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let minus = parseInt(input.val()) - 1;
            if (minus >= 0) {
                input.val(minus);
            } else {
                input.val(0);
            }
        })
    }

    ///////////////////////////////////////////////
    // EVENT DONT MAKE BUTTON APPEAR IF NO RMF36
    /////////////////////////////////////////////////
    if ($('.RMF19').length) {
        if ($('.RMF36').length == 0) {
            $('.page-scroll').css('display', 'none');
        }
    }
    ///////////////////////////////////////////////
    // MAP SUPER COMPLICATED OPTIONS
    // ///////////////////////////////////////////////
    $body.on('click', '.info', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
    });
    
    let map = $('.RGO11');
    let coordonnes = $('.RGO15');
    let coordonnes_map = $('.coordonneessec__right');
    let hours = $('.RGO14');
    if (map !== null || coordonnes !== null || hours !== null) {
        map.each(function () {
            //if map + hours
            if ($(this).next().hasClass('RGO14')) {
                $(this).addClass('and-hours');
                $(this).next(hours).addClass('and-map');
            }
            // //if coordonnees + map
            // if ($(this).prev().hasClass('RGO15') && $(this).find('.map').attr('data-address') == $(this).prev().find('.map').attr('data-address')) {
            //     $(this).addClass('and-coordonnes');
            //     if ($(this).next().hasClass('RGO14')) {
            //         $(this).prev(coordonnes).addClass('and-hours');
            //         $(this).next(hours).addClass('and-map');
            //     }
            //     //insert map in the map div
            //     $(this).prev(coordonnes).find(coordonnes_map).removeClass('hide');
            //     $(this).prev(coordonnes).find(coordonnes_map).append($(this));
            // }
        });
        coordonnes.each(function () {
            //if coordonnes + hours
            if ($(this).next().hasClass('RGO14')) {
                $(this).next(hours).addClass('and-map');
                $(this).addClass('and-hours');
            }
        });
    }
} // onLoad()
function reset() {
    // Remove event listeners
    $content.off();
    // Reset menu state
    $body.off().removeClass();

    prev_url = window.location.href;
} // reset()
function destroy() {
    window.scrollTo(0, 0);

    // Destroy select2
    if ($('.select2-hidden-accessible').length) $('.select2-hidden-accessible').select2('destroy');
    // Destroy slicks
    $('.slick-initialized').slick('unslick');
} // destroy()

/**
 * 
 * @author Maxime Doré
 * @description Apply an equal height to multiple element based on the tallest one
 * 
 * @param $context =    Ancestor of all other resizable elements
 * @param $toResize =   Element to resize
 * @param minWidth =    minimum width media query
 * @param maxWidth =    maximum width media query
 */
function giveSizeToOthers($context, $toResize, minWidth, maxWidth) {
    if ($context.length > 0) {
        if ($toResize.length > 0) {
            if (!minWidth) var minWidth = 0;    // compatibilité IE
            if (!maxWidth) var maxWidth = 9999;   // compatibilité IE
            if (viewport().width > minWidth && viewport().width < maxWidth) {
                $context.each(function () {
                    var height = 0;
                    var $objects = $(this).find('.' + $toResize.attr("class").split(' ')[0]);
                    $objects.each(function () {
                        if ($(this).is(':visible')) {
                            $objects.height('');
                            var currentHeight = $(this).children('.resize').outerHeight();
                            if (currentHeight > height) height = currentHeight;
                        }
                    });
                    $objects.height(height);
                });
            }
            else {
                var $objects = $context.find('.' + $toResize.attr("class").split(' ')[0]);
                $objects.height('');
            }
        } else if ($context.length > 0) {
            // console.log('"$toResize == undefined" dans giveSizeToOthers : '+$toResize.selector);
        }
    }
}

/**
 * @author Maxime Doré
 * @param  string targetDiv Query selector where the page will scroll (ex : "#content")
 * @param number offset   Negative top offset (ex: 100 means 100px higher)
 */
function scrollPage(targetDiv, offset) {
    if (!offset) var offset = $nav.height();

    if (!$body.hasClass('no-scroll') && $(targetDiv).length > 0) {
        if (!isSafari && !isIE) {
            window.scrollTo({ top: $(targetDiv).offset().top - offset, behavior: 'smooth' });
        } else {
            $('html, body').clearQueue().stop().animate({
                scrollTop: $(targetDiv).offset().top - offset
            }, 300);
        }
    }
}

// MIXITUP SCRIPT FOR IF MENU IS OVERFLOWING

function overflowCategoryCheck() {
    let filters = document.querySelectorAll('.filter_container');
    filters.forEach(filter => {
        let categoriesMenuList = filter.querySelector(".desktop_categories");
        let categoriesSelector = filter.querySelector(".select_wrapper");
        if (categoriesMenuList && categoriesSelector) {
            categoriesSelector.classList.add("hide");
            categoriesMenuList.classList.remove("hidden");
            if (categoriesMenuList.offsetWidth < categoriesMenuList.scrollWidth || categoriesMenuList.offsetWidth == 0) {
                categoriesSelector.classList.remove("hide");
                categoriesMenuList.classList.add("hidden");
            }
        }
    })
}

/*
function menu_distribute_links() {
    let r = document.querySelector(':root');
    let rs = getComputedStyle(r);

    let menu_size = $('.nav__box').outerWidth();
    let logo_size = $('.middle__logo').outerWidth();

    // percent taken by logo
    let percent_left = 100 - (logo_size * 100 / menu_size);
    let percent_per_sides = percent_left / 2;

    if ($('.hamburger_menu li').length > 0) {
        r.style.setProperty('--space_taken_by_left', `calc(${percent_per_sides}% - 72px)`);
        r.style.setProperty('--space_taken_by_right', `${percent_per_sides}%`);
    } else {
        r.style.setProperty('--space_taken_by_left', `${percent_per_sides}%`);
        r.style.setProperty('--space_taken_by_right', `${percent_per_sides}%`);
    }
}
*/

// Clear all form inputs
function clearForm($container) {
    $('input:not([type="submit"]):not([type="hidden"]), textarea', $container).val('').prop('checked', false).trigger('change');
    $('select', $container).val('').trigger('change');
}


// CODE TO REFRESH IF RESET FILTERS IS CLICKED 
$('.reset-filters').on('click', function () {
    let selects2 = $(this).closest('form').find('.select2');
    selects2.each(function () {
        return $(this).val('').trigger('change');
    })
    location.reload;
})


///////////////////////////////////////////////////////////////////////////
// NAV: REDUCE FONT-SIZE IF TEXT IS TOO LARGE FOR CONTAINER
///////////////////////////////////////////////////////////////////////////
function resizeText(container, text) {
    requestAnimationFrame(() => {
        if (container.hasClass('isResizing')) return;
        container.addClass('isResizing');
        let containerWidth = container.width();
        let fontSize = text.css('font-size');
        if (!text.data('OriginalFontSize')) text.data('OriginalFontSize', fontSize);
        text.css('white-space', 'nowrap');
        let textWidth = text.width();
        text.css('white-space', '');
        text.css('transition', 'none');
        if (textWidth > containerWidth) {
            let scale = containerWidth / textWidth;
            text.css('font-size', `${(parseFloat(fontSize) * scale)}px`);
        } else {
            text.css('font-size', '')
        }
        text.css('transition', '');
        container.removeClass('isResizing');
    })
}

// Resize Fn
function onResize() {
    if (window.innerWidth >= 1024) {
        $('.main__nav .btn').each((index, element) => resizeText($(element), $(element).find('.btn__text')));
        $('.main__nav .main_menu_el').each((index, element) => resizeText($(element), $(element).find('.main_menu__text')));
    }
    // giveSizeToOthers($('.row--600'), $('.resized'), 600);
    // giveSizeToOthers($('.row--768'), $('.resized'), 768);
    // giveSizeToOthers($('.row--900'), $('.resized'), 900);
    // giveSizeToOthers($('.row--1024'), $('.resized'), 1024);
    
    
    if (document.querySelector(".desktop_categories") !== null) {
        overflowCategoryCheck();
    }
    if (window.innerWidth >= 1024) {
        $('.hamburger__container').toggle(Boolean($('.hamburger_menu').length || $('.menu__buttons .btn-container .btn').length));
    } else {
        $('.hamburger__container').toggle(Boolean($('.mobile_menu').length || $('.menu__buttons .btn-container .btn').length));
    }
}
// Scroll Fn
function onScroll(e, posTop) {

    var scroll = $(window).scrollTop();
    if (scroll >= 30) {
        $(".RGO000-A").addClass("scrolled");
    } else {
        $(".RGO000-A").removeClass("scrolled");
    }
    if (!$html.hasClass("is-animating")) {
        if (!posTop) posTop = $(window).scrollTop();
        if (posTop > 20) {
            $body.addClass("scroll");
        } else {
            $body.removeClass("scroll");
        }
        $(".visible").each(function () {
            var $this = $(this);
            if ($this.is(":in-viewport()")) {
                $this.addClass("alive");
                // if ($this.find("video[autoplay][muted]").length) {
                //     $this.find("video[autoplay][muted]")[0].play();
                //     $this.find($('.video__wrapper')).addClass('playing');
                // }
                // if ($this.hasClass("slick-initialized") && $this.slick("slickGetOption", "autoplay")) {
                //     $this.slick("slickPlay");
                // }
            } else if (!$this.hasClass("once")) {
                $this.removeClass("alive done");
                // if ($this.find("video[autoplay][muted]").length) {
                //     $this.find("video[autoplay][muted]")[0].pause();
                // }
                // if ($this.hasClass("slick-initialized") && $this.slick("slickGetOption", "autoplay")) {
                //     $this.slick("slickPause");
                // }
            }
        });
    }
}

$(window).on('resize', $.throttle(100, onResize));
$(window).on('scroll', $.throttle(100, onScroll));
$(window).on('load', function () {
    $html.removeClass('is-animating');
    onLoad();
});

if (typeof backgroundSetter === "function") {
    bgSetter = new backgroundSetter();
    bgSetter.init();
}

$(window).on('resetDOM', function () {
    if (typeof backgroundSetter === "function") {
        new backgroundSetter().init();
    }
});

/**********************new********************/

$(document).ready(function () {
    ///////////////////////////////////////////////////////////////////////////
    // Main Menu
    ///////////////////////////////////////////////////////////////////////////
    // $('.nav__box').addClass(`elements-${$('.main_menu_el').length}`);
    const leftContainer = document.querySelector('.nav__container .nav__container-left');
    if (leftContainer) {
        const leftSideCount = leftContainer.childElementCount;
        leftContainer.classList.toggle('grow', leftSideCount > 1);
    }
    const rightContainer = document.querySelector('.nav__container .nav__container-right');
    if (rightContainer) {
        const rightSideCount = rightContainer.childElementCount;
        rightContainer.classList.toggle('grow', rightSideCount > 2);
    }
    ///////////////////////////////////////////////////////////////////////////
    // Hummmburger Menu
    ///////////////////////////////////////////////////////////////////////////

    $('.hamburger__icon').click(function () {
        // if( $('body:not(.scroll)').length > 0 ) {
        //     setTimeout(function() {
        //         $('.hamburger__icon').toggleClass('active');
        //     }, 250);
        // } else {
        // }
        setTimeout(function () {
            $('.hamburger__icon').toggleClass('active');
        }, 250);
        $('.menu_main').toggleClass('activemenumain');
        $('body').toggleClass('activemenu fixbody');
        $('header').toggleClass('nav-open');
    });

    // if ($("body").hasClass(".scroll.activemenu.fixbody")) {
    //     $(".hamburger__icon.active").click(function() {
    //         $(this).removeClass('active');
    //     }); 
    // }

    $('.hamburgermenu .menu__image').click(function () {
        // if( $('body:not(.scroll)').length > 0 ) {
        //     setTimeout(function() {
        //         $('.hamburger__icon').removeClass('active');
        //     }, 250);
        // } else {
        // }
        setTimeout(function () {
            $('.hamburger__icon').removeClass('active');
        }, 250);
        $('.menu_main').removeClass('activemenumain');
        $('body').removeClass('activemenu fixbody');
        $('header').removeClass('nav-open');
    });

    $(".nav__box ul li:has(ul)").addClass('hassubmenu');

    $(".menu_main nav li:has(ul) > a").click(function () {
        $(this).siblings("ul").slideToggle("slow"), $(this).toggleClass("minus")
    })

    $(".hamburgermenu__nav nav li:has(ul) a, .hamburgermenu__nav nav li:has(ul) .link").click(function () {
        $(this).siblings("ul").slideToggle("slow").toggleClass("sidemenutoggle"), $(this).find('.arrow-up').toggleClass("arrow-down");
    });

    $(".menu_main nav li:has(ul) > a, .menu_main nav li:has(ul) > .link").prepend('<span class="arrow plus-icon"></span>')

    ///////////////////////////////////////////////////////////////////////////
    // Footer menu
    ///////////////////////////////////////////////////////////////////////////

    let $footerContainer = $('footer .footer__nav');
    if ($footerContainer) {
        const menuCount = $footerContainer.length;
        switch (menuCount) {
            case 1:
                $footerContainer.addClass('one_menu');
                break;

            case 2:
                $footerContainer.addClass('two_menu');
                break;

            case 3:
                $footerContainer.addClass('three_menu');
                break;

            case 4:
                $footerContainer.addClass('four_menu');
                break;

            case 5:
                $footerContainer.addClass('five_menu');
                break;

            default:
                break;
        }
    }

    ///////////////////////////////////////////////////////////////////////////
    // Slick
    ///////////////////////////////////////////////////////////////////////////
    $('.RMF08-slick').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        draggable: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        rows: 0
    });

    $('.slick--RMF02').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        dots: true,
        autoplaySpeed: 2000,
        draggable: true,
        rows: 0
    });

    $('.slick--RMF16').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        fade: true,
        arrows: false,
        autoplay: false,
        dots: true,
        autoplaySpeed: 2000,
        draggable: true,
        rows: 0
    })
        .on('beforeChange', function (e, slick, currentSlide) {
            $(this).find('.slick-active').addClass('stay');
        })
        .on('afterChange', function (e, slick, currentSlide) {
            setTimeout(() => {
                $(this).find('.slick-slide.stay').removeClass('stay');
            }, 300);
        });

    $('.slick--RGO07').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: false,
        rows: 0,
        responsive: [{
            breakpoint: 1000,
            settings: {
                draggable: true,
                slidesToShow: 2
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            },
        }],
    })
        .on('afterChange', function (e, slick, currentSlide) {
            $(window).trigger('scroll');
        });

    $('.slick--RMO03').slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: false,
        responsive: [{
            breakpoint: 1000,
            settings: {
                draggable: true,
                slidesToShow: 2
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,

            },
        },
        ], // Adds the dots on the bottom
    })
        .on('afterChange', function (e, slick, currentSlide) {
            $(window).trigger('scroll');
        });

    $('.slick--RMO05').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: false,
        rows: 0,
        responsive: [{
            breakpoint: 1240,
            settings: {
                draggable: true,
                slidesToShow: 2
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,

            },
        },
        ], // Adds the dots on the bottom
    })
        .on('afterChange', function (e, slick, currentSlide) {
            $(window).trigger('scroll');
        });

    $('.slick--RMO06').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        draggable: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    draggable: true,
                    slidesToShow: 2
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                }
            }
        ] // Adds the dots on the bottom
    })
        .on('afterChange', function (e, slick, currentSlide) {
            $(window).trigger('scroll');
        });

    $('.slick--RMO07').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        rows: 0,
        responsive: [{
            breakpoint: 1400,
            settings: {
                draggable: true,
                slidesToShow: 2
            },
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 1,

            },
        },
        ], // Adds the dots on the bottom
    })
        .on('afterChange', function (e, slick, currentSlide) {
            $(window).trigger('scroll');
        });

    $('.slick--RMO08').slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        rows: 0,
        responsive: [{
            breakpoint: 1000,
            settings: {
                draggable: true,
                slidesToShow: 1,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,

            },
        },
        ], // Adds the dots on the bottom
    })
        .on('afterChange', function (e, slick, currentSlide) {
            $(window).trigger('scroll');
        });

    $('.slick--RMO10').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        draggable: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    draggable: true,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                },
            },
        ], // Adds the dots on the bottom
    })
        .on('afterChange', function (e, slick, currentSlide) {
            $(window).trigger('scroll');
        });


    if (window.innerWidth >= 769) {
        $('.slick--RMO09').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 2000,
            draggable: true,
            rows: 0,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        draggable: true,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    $('.slick--gallery').each(function () {
        $(this).slick({
            infinite: false,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            dots: false,
            fade: true,
            autoplaySpeed: 2000,
            draggable: true,
            prevArrow: $(this).siblings('.sliderarrows').find('.prev'),
            nextArrow: $(this).siblings('.sliderarrows').find('.next'),
            rows: 0
        })
        // .on('beforeChange', function (e, slick, currentSlide) {
        //     $(this).find('.slick-active').addClass('stay');
        // })
        // .on('afterChange', function (e, slick, currentSlide) {
        //     setTimeout(() => {
        //         $(this).find('.slick-slide.stay').removeClass('stay');
        //     }, 0);
        // });
    });

    $('.slick--RMO13').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        adaptiveHeight: true,
        rows: 0,
    });

    $('.partners__carousel').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        rows: 0,
        responsive: [{
            breakpoint: 1300,
            settings: {
                draggable: true,
                slidesToShow: 3
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,

            },
        },
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,

            },
        }
        ], // Adds the dots on the bottom
    });

    $('.heures-ouvertures__carousel').slick({
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        draggable: false,
        rows: 0,
        responsive: [{
            breakpoint: 1000,
            settings: {
                draggable: true,
                slidesToShow: 4
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,

            },
        },
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 2,

            },
        }
        ], // Adds the dots on the bottom
    });

    $('.produitsannonces__slider').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        draggable: true,
        rows: 0,
        responsive: [{
            breakpoint: 1000,
            settings: {
                draggable: true,
                slidesToShow: 2
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,

            },
        },
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,

            },
        }
        ], // Adds the dots on the bottom
    });

    $('.suivantdate__wrap').slick({
        infinite: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        draggable: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        rows: 0,
        responsive: [{
            breakpoint: 1100,
            settings: {
                draggable: true,
                slidesToShow: 5,
            },
        },
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 4,

            },
        },
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 3,

            },
        }
        ], // Adds the dots on the bottom
    });

    $('.slick--RGO21').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        adaptiveHeight: false,
        rows: 0
    });

    ///////////////////////////////////////////////////////////////////////////
    // ACCORDIONS
    ///////////////////////////////////////////////////////////////////////////

    $('.plandesitemap__header .plandesitemap__btn').click(function () {
        // $('.plandesitemap__content').toggleClass('active');
        // $('.plandesitemap__box').toggleClass('active');
        // $('.plandesitemap__content.active').removeClass('active');
        // $('.plandesitemap__box.active').removeClass('active');
    });

    $(".faq__accordian-content").css("display", "none");

    $(".faq__header").click(function () {
        $(".open").not(this).removeClass("open").next().slideUp(300);
        $(this).toggleClass("open").next().slideToggle(300);
    });

    ///////////////////////////////////////////////////////////////////////////
    // Button Hover Effect
    ///////////////////////////////////////////////////////////////////////////
    $('.btn--primary')
        .on('mouseenter', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('.animate').css({ top: relY, left: relX })
        })
        .on('mouseout', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('.animate').css({ top: relY, left: relX })
        });
    $('a[href="#"]').click(function () { return false });

    ///////////////////////////////////////////////////////////////////////////
    // Sitemap
    ///////////////////////////////////////////////////////////////////////////
    $('.plandesitemap__box .plandesitemap__header').click(function () {
        if ($(this).parent().hasClass('active')) {
            $(this).siblings().slideUp();
            $(this).parent().removeClass('active');
        } else {
            $('.plandesitemap__box.active .plandesitemap__header').siblings().slideUp(function () {
                $(this).parent().removeClass('active');
            })
            $(this).siblings().slideDown();
            $(this).parent().addClass("active");
        }
    });

    ///////////////////////////////////////////////////////////////////////////
    // RMO21
    ///////////////////////////////////////////////////////////////////////////
    if ($('.RMO21').length) {
        $body.on('click', '.filtrescat__categories input[type="radio"]', function () {
            var $this = $(this);
            var $parent = $this.parents('.filtrescat__categories');
            // remove all active class to each label
            $parent.find('label').removeClass('active');
            // add active class to the checked label
            $this.parent().addClass('active');
        });
    }

    $(".left__sidebar .sidebar__box li:has(ul)").addClass('hassubmenu');

    $('.filtres__toggle').click(function () {
        $(this).parents('.filtrescat__filtres').toggleClass('active_dropdown');
    });

    $('.categorie--box .plus-icon').click(function () {
        $(this).siblings('ul').slideToggle().toggleClass('toggleul');
        $(this).toggleClass("active");
    });

    $(document).on('click', '.upload-box .file-button.uploaded', function () {
        var defaultText = $(this).parents('.inputfile-box').find('input[type="file"]').attr('placeholder');
        $(this).parents('.inputfile-box').find('input[type="file"]').val('');
        $(this).parent().find('.file-name').html(defaultText);
        $(this).parent().find('.fas').removeClass('fa-trash-alt').fadeOut();
        $(this).parent().find('.fas').fadeIn(1, function () {
            $(this).parent().find('.fas').addClass('fa-upload').fadeIn("slow");;
        });
        $(this).removeClass('uploaded');
        return false;
    });

    $(document).on('click', 'form .button--text .btn--secondary', function () {
        $(this).parents('form').trigger('reset');
        var defaultText = $(this).parents('form').find('input[type="file"]').attr('placeholder');
        $(this).parents('form').find('.file-name').html(defaultText);
        $(this).parents('form').find('.fas.fa-trash-alt').addClass('fa-upload');
        $(this).parents('form').find('.fas.fa-trash-alt').removeClass('fa-trash-alt');
        $(this).parents('form').find('.upload-box .file-button').removeClass('uploaded');
        return false;
    });

    $('#form_id').trigger("reset");


    $(document).on('keydown keyup', '.promotionnel--box input[name="promotionnel"]', function () {
        if ($(this).val().length > 30) {
            $(this).parent().removeClass('flex--2-third');
            $(this).parent().addClass('flex--full');
        } else {
            $(this).parent().removeClass('flex--full');
            $(this).parent().addClass('flex--2-third');
        }
    });

    // remove class first-loading from html
    $('html').removeClass('first-loading');
});

function uploadFile(target) {
    let parent = $(target).parent();
    parent.find('.file-name').html(target.files[0].name);
    parent.find('.fas').removeClass('fa-upload').fadeOut();
    parent.find('.fas').fadeIn(1, function () {
        parent.find('.fas').addClass('fa-trash-alt').fadeIn("slow");;
    });
    parent.find('.file-button').addClass('uploaded');
}
window.uploadFile = uploadFile;

function togglePlayMedia(container) {
    let media = container[0].querySelector('video');
    if (container[0].classList.contains('playing')) {
        container[0].classList.remove('playing');
        media.pause();
    } else {
        container[0].classList.add('playing');
        media.play();
    }
}

function toggleSoundMedia(container) {
    let media = container[0].querySelector('video');
    if (media.muted) {
        container[0].classList.add('volume-up');
        media.muted = false;
    } else {
        container[0].classList.remove('volume-up');
        media.muted = true;
    }
}